import Controller from "@/inline-assets/controller.svg";
import Mouse from "@/inline-assets/mouse.svg";
import stringsToSymbols from "@/util/strings-to-symbols.mjs";

const FORTNITE_PLATFORMS_LIST = ["pc", "console"] as const;
export const FORTNITE_PLATFORMS_SYMBOLS = stringsToSymbols([
  ...FORTNITE_PLATFORMS_LIST,
]);

export const FORTNITE_PLATFORMS = {
  [FORTNITE_PLATFORMS_SYMBOLS.pc]: {
    key: "pc",
    t: ["fortnite:platforms.pc", "PC"] as Translation,
    icon: Mouse,
    inputType: "KEYBOARDMOUSE",
  },
  [FORTNITE_PLATFORMS_SYMBOLS.console]: {
    key: "console",
    t: ["fortnite:platforms.console", "Console"] as Translation,
    icon: Controller,
    inputType: "GAMEPAD",
  },
};

export type PlatformType = (typeof FORTNITE_PLATFORMS_LIST)[number];
export type InputType =
  (typeof FORTNITE_PLATFORMS)[keyof typeof FORTNITE_PLATFORMS]["inputType"];
